<template>
  <div>
    <div class="content">

        <div class="container-fluid mt-4">

            <stats-card title="System" type="dark" sub-title="Settings" icon="fas fa-tools">

              <template slot="append">
                <b-card no-bod class="tab-wrapper">
                  <b-card-header header-tag="nav">
                      <b-nav card-header tabs>
                          <b-nav-item @click="setActiveTab(2)"  :active="activeTab == 2">APIs status</b-nav-item>
                          <b-nav-item @click="setActiveTab(1)"  :active="activeTab == 1">Mobile app</b-nav-item>
                      </b-nav>
                  </b-card-header>

                  <div class="tab-container" v-if="activeTab == 2">
                    <base-alert>
                        List of all RapidAIM APIs current status will go here
                    </base-alert>
                  </div>

                  <div class="tab-container" v-if="activeTab == 1">
                    <base-alert :action="updateVersionAction()">
                          Current app version is <strong>1.6.0</strong>
                    </base-alert>
                  </div>

                </b-card>
              </template>
            </stats-card>
        </div>
    </div>

    <modal :show.sync="showUpdateAppVersion">
        <h6 slot="header" class="modal-title">Update app version</h6>

        <base-alert>
            Users will be notified next time they use the app.
        </base-alert>

        <base-input label="New version:" v-model="newAppVersion"></base-input>

        <template slot="footer">
            <base-button type="blank" @click="showUpdateAppVersion = false">Cancel</base-button>
            <base-button type="primary" :disabled="newAppVersion == ''" @click="updateAppVersion">Update</base-button>
        </template>
    </modal>
  </div>
  
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      activeTab: 2,
      showUpdateAppVersion: false,
      newAppVersion: ''
    };
  },
  methods: {
    updateAppVersion: async function() {
      // this.$emit('loading', true);
    },
    setActiveTab: function(tab) {
        this.activeTab = tab
    },
    toggleUpdateAppVersion: function() {
      this.showUpdateAppVersion = true
    },
    updateVersionAction: function() {
      var qwd = this.toggleUpdateAppVersion
      return {
        label: 'Update',
        callback: function() {
          qwd()
        }
      }
    }
  }
};
</script>
